import React, {useEffect, useState} from 'react';
import './style.scss';
import config from './config.json';
import BodyText from "../../components/body-text/main";


export default function Footer(props) {
    return (
        <footer className="footer">
            <div className="inner">
                <BodyText content={config} />

                <div className="contacts">
                    {config.contacts.map((contact, key) => {
                        return (
                            <div className="contact" key={key}>
                                <h3 className="location" dangerouslySetInnerHTML={{__html:contact.location}}></h3>
                                <span className="name" dangerouslySetInnerHTML={{__html:contact.name}}></span>
                                <span className="position" dangerouslySetInnerHTML={{__html:contact.position}}></span>
                                <p className="address" dangerouslySetInnerHTML={{__html:contact.address}}></p>
                            </div>
                        )
                    })}
                </div>
            </div>
        </footer>
    )
}
